<template lang="pug">
  app-modal(v-model="modalSelGroup")
    template(slot="header")
      button.close(type="button", @click="setDefaultGroups"): span &times;
      h4.modal-title
        | 組織の選択
    slot
      ul.bcard-tree.bcard-group-tree-modal
        group-tree-item(
          :onClickName="setGroups",
          :selectedIds="selected_ids",
          :maxSelect="maxSelect",
          :showRoot="false",
          :showNodata="true"
        )
    template(slot="footer")
      button.btn.btn-primary(@click="updateGroups") OK
      button.btn.btn-default(@click="setDefaultGroups") キャンセル
</template>

<script>
import GroupTreeItem from '@/components/organisms/GroupTreeItem'
import AppModal from '@/components/templates/AppModal'

export default {
  name: 'ModalSelGroup',
  components: { AppModal, GroupTreeItem },
  // 選択中の組織ID
  props: {
    // ダイアログ表示フラグ
    openFlag: {type: Boolean, required: true, default: false},
    // 初期選択組織
    defaultGroups: {type: Array, required: false, default: null},
    // 選択上限数（1以外を設定すると複数選択処理）
    maxSelect: {type: Number, required: false, default: 1},
    // 選択解除対象ID
    deselectedId: {type: Number, required: false, default: null}
  },
  data: function () {
    return {
      selected_ids: [],
      selected_names: [],
      modalSelGroup: false
    }
  },
  watch: {
    deselectedId: function () {
      // 選択中組織から解除
      if (this.deselectedId !== null) {
        const count = this.selected_ids.length
        for (let i = 0; i < count; i++) {
          if (this.selected_ids[i] === this.deselectedId) {
            this.selected_ids.splice(i, 1)
            this.selected_names.splice(i, 1)
            break
          }
        }
        // 選択解除完了を親に伝える
        this.$emit('complete-deselection')
      }
    },
    openFlag: function () {
      // ダイアログを開く場合
      if (this.openFlag) {
        // AppModalにフラグを渡す
        this.modalSelGroup = this.openFlag
        // 親のフラグを下げさせる
        this.$emit('get-flag')
      }
    }
  },
  created: function () {
    this.setDefaultGroups()
  },
  methods: {
    setDefaultGroups () {
      // 初期化
      this.selected_ids = []
      this.selected_names = []
      // 初期データがある場合は保存
      if (this.defaultGroups !== null) {
        const count = this.defaultGroups.length
        for (let i = 0; i < count; i++) {
          this.selected_ids.push(this.defaultGroups[i].id)
          this.selected_names.push(this.defaultGroups[i].name)
        }
      }
      this.modalSelGroup = false
    },
    // ツリーコンポーネントに渡して実行させる
    // 選択組織の追加、解除
    setGroups (group) {
      // 選択済み組織の場合
      if (group.selected) {
        // 配列から組織情報を削除
        if (this.selected_ids !== null) {
          const count = this.selected_ids.length
          for (let i = 0; i < count; i++) {
            if (this.selected_ids[i] === group.id) {
              this.selected_ids.splice(i, 1)
              this.selected_names.splice(i, 1)
              break
            }
          }
        }
      }
      // 未選択の組織の場合
      else {
        // 単数選択の場合
        if (this.maxSelect === 1) {
          // 選択中の組織を更新
          this.selected_ids = [group.id]
          this.selected_names = [group.name]
        }
        else {
          // 現在の選択数が上限未満なら配列に追加
          if (this.selected_ids.length < this.maxSelect) {
            this.selected_ids.push(group.id)
            this.selected_names.push(group.name)
          }
        }
      }
    },
    // 選択ボタン押下時
    updateGroups () {
      let groups = []
      if (this.selected_ids !== null) {
        const count = this.selected_ids.length
        for (let i = 0; i < count; i++) {
          // 選択組織のデータをまとめる
          let group = {
            id: this.selected_ids[i],
            name: this.selected_names[i]
          }
          groups.push(group)
        }
      }
      // 選択中の組織を渡す
      this.$emit('set-groups', groups)
      this.modalSelGroup = false
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/organisms/ModalSelGroup.vue